function extractedIPPCoem() {
    if ($("#ippQuotiteCoemprunteur").length > 0) {
        if ($(this).val() < $(this).data('min-api')) {
            $("#ippQuotiteCoemprunteur").val($(this).data('min-api'));
            $("#ippQuotiteCoemprunteur").next().html($(this).data('min-api') + "%");
        } else {
            $("#ippQuotiteCoemprunteur").val($(this).val());
            $("#ippQuotiteCoemprunteur").next().html($(this).val() + "%");
        }
    }
}

function extractedIPTICoem() {
    if ($("#iptiQuotiteCoemprunteur").length > 0) {
        if ($(this).val() < $(this).data('min-api')) {
            $("#iptiQuotiteCoemprunteur").val($(this).data('min-api'));
            $("#iptiQuotiteCoemprunteur").next().html($(this).data('min-api') + "%");
        } else {
            $("#iptiQuotiteCoemprunteur").val($(this).val());
            $("#iptiQuotiteCoemprunteur").next().html($(this).val() + "%");
        }
    }
}

function extractedIPTCoem() {
    if ($("#iptQuotiteCoemprunteur").length > 0) {
        if ($(this).val() < $(this).data('min-api')) {
            $("#iptQuotiteCoemprunteur").val($(this).data('min-api'));
            $("#iptQuotiteCoemprunteur").next().html($(this).data('min-api') + "%");
        } else {
            $("#iptQuotiteCoemprunteur").val($(this).val());
            $("#iptQuotiteCoemprunteur").next().html($(this).val() + "%");
        }
    }
}

function extractedIPP() {
    if ($("#ippQuotiteEmprunteur").length > 0) {
        if ($(this).val() < $(this).data('min-api')) {
            $("#ippQuotiteEmprunteur").val($(this).data('min-api'));
            $("#ippQuotiteEmprunteur").next().html($(this).data('min-api') + "%");
        } else {
            $("#ippQuotiteEmprunteur").val($(this).val());
            $("#ippQuotiteEmprunteur").next().html($(this).val() + "%");
        }
    }
}

function extractedIPTI() {
    if ($("#iptiQuotiteEmprunteur").length > 0) {
        if ($(this).val() < $(this).data('min-api')) {
            $("#iptiQuotiteEmprunteur").val($(this).data('min-api'));
            $("#iptiQuotiteEmprunteur").next().html($(this).data('min-api') + "%");
        } else {
            $("#iptiQuotiteEmprunteur").val($(this).val());
            $("#iptiQuotiteEmprunteur").next().html($(this).val() + "%");
        }
    }
}

function extractedIPT() {
    if ($("#iptQuotiteEmprunteur").length > 0) {
        if ($(this).val() < $(this).data('min-api')) {
            $("#iptQuotiteEmprunteur").val($(this).data('min-api'));
            $("#iptQuotiteEmprunteur").next().html($(this).data('min-api') + "%");
        } else {
            $("#iptQuotiteEmprunteur").val($(this).val());
            $("#iptQuotiteEmprunteur").next().html($(this).val() + "%");
        }
    }
}

$(document).ready(function () {
    const euro = new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2
    });

    $('label.noRequiredClass').removeClass('required');

    // $('form.submit-disabled-if-reject').find(':submit').attr('disabled', 'disabled');
    let block = false;
    const nameOfRejects = [
        'projet[assuranceConcerne]',
        'pret[cbPret]',
        'pret2[pretDuree1]',
        'pret2[pretDuree2]',
        'pret2[pretDuree3]',
    ];

    const nameOfRejectsPretType = [
        'pret2[pretType1]',
        'pret2[pretType2]',
        'pret2[pretType3]',
    ];

    $(".close-zone").click(function () {
        let str = this.dataset.nameclose;
        let tab = str.split(",");
        for (let i = 0; i < tab.length; i++) {
            $("#" + tab[i]).hide();
        }
    });

    $(".open-zone").click(function () {
        let str = this.dataset.nameopen;
        let tab = str.split(",");
        for (let i = 0; i < tab.length; i++) {
            $("#" + tab[i]).show();
        }
    });

    /**
     *     Premier écran - On cache / affiche les blocs au chargement (permet d'afficher ou pas élodie si des saisies ont été faites)
     */
    if ($("#projet\\[titreProjet\\]").length > 0) {
        desactiveFormSiMultipleRejet(true, ['projet[projetConcerne]', 'projet[assuranceConcerne]', 'projet[nbPersonnes]']);
        afficherBloc("projet[projetConcerne]");
        afficherBloc("projet[assuranceConcerne]");
        afficherBloc("projet[nbPersonnes]");
    }
    /**
     *     Deuxième écran - On cache / affiche les blocs au chargement - methode de calcul du restant a venir
     */
    if ($("#totalMontant").length > 0) {
        $(".montantDePret").hide();
        $(".questionNbPretLabel").hide();
        desactiveFormSiMultipleRejet(false);
        afficherBloc("pret[financement]");
        declencherCalculMontantRestant();
        calculMontantRestantDevisGsp();
    }

    if ($("#montantRecappret1").length > 0) {
        $('#montantRecappret1').html(euro.format($("#montantRecappret1").html()));
        $('#montantRecappret2').html(euro.format($("#montantRecappret2").html()));
        $('#montantRecappret3').html(euro.format($("#montantRecappret3").html()));
        afficherBloc("pret2[pretDiffere1]");
        afficherBloc("pret2[pretDiffere2]");
        afficherBloc("pret2[pretDiffere3]");
        afficherBloc("pret2[pretBanque1]");
        afficherBloc("pret2[pretBanque2]");
        afficherBloc("pret2[pretBanque3]");
        desactiveFormSiMultipleRejet(true, nameOfRejectsPretType);
    }
    /**
     *     Quatrième écran - On cache / affiche les blocs au chargement (permet d'afficher ou pas élodie si des saisies ont été faites)
     */
    afficherBloc("infosPerso[contratPrevoyanceEmprunteur]");
    afficherBloc("infosPerso[contratPrevoyanceCoemprunteur]");


    /**
     *      Cinquieme écran - On gérer l'affichage des values des input range
     */
    if ($("#iptiQuotiteEmprunteur").length > 0) {
        afficherBloc("garanties[iptiQuestionEmprunteur]");
        afficherBloc("garanties[iptiQuestionCoemprunteur]");
        afficherValueInputRange();
    }

    // Range emprunteur
    $(document).on('input change', '#iptiQuotiteEmprunteur', function () {
        setNouvellesValInputRange($(this), $(this).val(), $(this).data('min-api'), "QuotiteCoemprunteur");
        $("#iptiQuotiteEmprunteur").next().html($(this).val() + "%");
        extractedIPT.call(this);
        extractedIPP.call(this);
    });
    $(document).on('input change', '#iptQuotiteEmprunteur', function () {
        setNouvellesValInputRange($(this), $(this).val(), $(this).data('min-api'), "QuotiteCoemprunteur");
        $("#iptQuotiteEmprunteur").next().html($(this).val() + "%");
        extractedIPTI.call(this);
        extractedIPP.call(this);
    });
    $(document).on('input change', '#ippQuotiteEmprunteur', function () {
        setNouvellesValInputRange($(this), $(this).val(), $(this).data('min-api'), "QuotiteCoemprunteur");
        $("#ippQuotiteEmprunteur").next().html($(this).val() + "%");
        extractedIPT.call(this);
        extractedIPTI.call(this);
    });
    // Range Coemprunteur
    $(document).on('input change', '#iptiQuotiteCoemprunteur', function () {
        setNouvellesValInputRangeCoemprunteur($(this), $(this).val(), $(this).data('min-api'), "QuotiteEmprunteur");
        $("#iptiQuotiteCoemprunteur").next().html($(this).val() + "%");
        extractedIPTCoem.call(this);
        extractedIPPCoem.call(this);
    });
    $(document).on('input change', '#iptQuotiteCoemprunteur', function () {
        setNouvellesValInputRangeCoemprunteur($(this), $(this).val(), $(this).data('min-api'), "QuotiteEmprunteur");
        $("#iptQuotiteCoemprunteur").next().html($(this).val() + "%");
        extractedIPTICoem.call(this);
        extractedIPPCoem.call(this);
    });

    $(document).on('input change', '#ippQuotiteCoemprunteur', function () {
        setNouvellesValInputRangeCoemprunteur($(this), $(this).val(), $(this).data('min-api'), "QuotiteEmprunteur");
        $("#ippQuotiteCoemprunteur").next().html($(this).val() + "%");
        extractedIPTCoem.call(this);
        extractedIPTICoem.call(this);
    });
    let tabParam = {};

    function checkBeforeSendDevis(divId) {
        divId.forEach(function (item) {
            if ($('#' + item).length) {
                tabParam[item] = $('#' + item).is(":checked");
            } else tabParam[item] = false;
        });
        return tabParam;
    }

    let divId = ["EmprunteurIPPpret1", "EmprunteurMRpret1", "CoemprunteurIPPpret1", "CoemprunteurMRpret1"];
    tabParam = checkBeforeSendDevis(divId);
    /**
     *      Huitieme écran - Récapitulatif
     */
    $(".euroTransform").each(function () {
        $(this).html(euro.format($(this).html()));
    });

    $('.recalculerTarifBeforeDevis').on('change', function () {
        let tabParamNew = {}
        divId.forEach(function (item) {
            if ($('#' + item).length) {
                tabParamNew[item] = $('#' + item).is(":checked");
            } else tabParamNew[item] = false;
        });

        if (JSON.stringify(tabParam) === JSON.stringify(tabParamNew)) {
            $("#error_div_recalcul").hide();
            $('#nexttarif').show();
        } else {
            let erreurAff = '<p className="mb-0"><strong>Attention : </strong> Pour prendre en compte dans le tarif global l’/les option(s) sélectionnée(s), merci de cliquer sur le bouton “Recalculer le tarif”.</p>';
            $("#error_div_recalcul").html(erreurAff);
            $("#error_div_recalcul").show();
            $('#nexttarif').hide();
        }
    });

    $('#nextMail').on('click', function () {
        let successAff = '<p className="mb-0"><strong>Votre proposition tarifaire vient de vous être envoyée par mail.</strong></p>';
        $("#nextMailSucces").html(successAff);
        $("#nextMailSucces").addClass("collapsed");
        $("#nextMailSucces").removeClass("collapse");
    });
    $('#nexttarif').on('click', function () {
        let checked = false;
        $("input[name='capital']").each(function () {
            if ($(this).prop("checked") === true) {
                checked = true;
            }
        });
        if (!checked) {
            let erreurAff = '<p className="mb-0"><strong>Attention : </strong> Pour obtenir votre devis, vous devez sélectionner une des propositions ci-dessus.</p>';
            $("#error_div_simu").html(erreurAff);
            $("#error_div_simu").addClass("collapsed");
            $("#error_div_simu").removeClass("collapse");
            return false;
        } else {
            $("#error_div_simu").addClass("collapse");
            $("#error_div_simu").removeClass("collapsed");
        }
    });


    $('#nextPdf').on('click', function () {
        var win = window.open($("#urlPdf").val(), '_blank');
        if (win) {
            win.focus();
        } else {
            alert('Merci d\'autoriser les popup pour notre site web');
        }
    });
    $('#nextPdfCo').on('click', function () {
        var win = window.open($("#urlPdfCo").val(), '_blank');
        if (win) {
            win.focus();
        } else {
            alert('Merci d\'autoriser les popup pour notre site web');
        }
    });

    if ($("#departementEmprunteur").length > 0) {

        $("#departementEmprunteur").on("change", function (e) {
            let value = $(this).val();
            let valueCo = "";
            if ($("#departementCoemprunteur").length > 0) {
                $("#departementCoemprunteur").prop('required', 'required');
                valueCo = $("#departementCoemprunteur option:selected").val();
            }

            if (value != "98" && value !== "") {
                if (valueCo != "98") {
                    $('.gsp-right').removeAttr('disabled');
                    $('.gsp-right').show();
                }
                $("#departementEmprunteurStatic").hide();
                $("#departementEmprunteurStaticError").hide();
                return true;
            } else if (value === "") {
                $('.gsp-right').attr('disabled', 'disabled');
                $('.gsp-right').hide();
                $("#departementEmprunteurStaticError").show();
                $("#departementEmprunteurStatic").hide();
                return false;
            } else {
                $('.gsp-right').attr('disabled', 'disabled');
                $('.gsp-right').hide();
                $("#departementEmprunteurStatic").show();
                $("#departementEmprunteurStaticError").hide();
                return false;
            }
        });

        $(".gsp-right").on("click", function (e) {
            e.stopPropagation();
            $("#departementEmprunteur").prop('required', 'required');
            let valueCo = null;
            let value = $("#departementEmprunteur option:selected").val();
            if ($("#departementCoemprunteur").length > 0) {
                $("#departementCoemprunteur").prop('required', 'required');
                valueCo = $("#departementCoemprunteur option:selected").val();
            }
            if (value != "98" && value !== "" && valueCo != "98" && valueCo !== "") {
                $('.gsp-right').removeAttr('disabled');
                $('.gsp-right').show();
                return true;
            } else if (value === "") {
                $('.gsp-right').attr('disabled', 'disabled');
                $('.gsp-right').hide();
                $("#departementEmprunteurStaticError").show();
                $("#departementEmprunteurStatic").hide();
                return false;
            } else if (valueCo === "") {
                $('.gsp-right').attr('disabled', 'disabled');
                $('.gsp-right').hide();
                $("#departementCoemprunteurStaticError").show();
                $("#departementCoemprunteurStatic").hide();
                return false;
            } else if (value == "98") {
                $('.gsp-right').attr('disabled', 'disabled');
                $('.gsp-right').hide();
                $("#departementEmprunteurStaticError").hide();
                $("#departementEmprunteurStatic").show();
                return false;
            } else if (valueCo == "98") {
                $('.gsp-right').attr('disabled', 'disabled');
                $('.gsp-right').hide();
                $("#departementCoemprunteurStaticError").hide();
                $("#departementCoemprunteurStatic").show();
                return false;
            }
        });
    }

    if ($("#departementCoemprunteur").length > 0) {
        $("#departementCoemprunteur").on("change", function (e) {
            let valueEmprunteur = $("#departementEmprunteur option:selected").val();
            let value = $(this).val();
            if (value != "98" && value !== "") {
                if (valueEmprunteur != "98" && valueEmprunteur !== "") {
                    $('.gsp-right').removeAttr('disabled');
                    $('.gsp-right').show();
                }
                $("#departementCoemprunteurStatic").hide();
                $("#departementCoemprunteurStaticError").hide();
                return true;
            } else if (value === "") {
                $('.gsp-right').attr('disabled', 'disabled');
                $('.gsp-right').hide();
                $("#departementCoemprunteurStaticError").show();
                $("#departementCoemprunteurStatic").hide();
                return false;
            } else {
                $('.gsp-right').attr('disabled', 'disabled');
                $('.gsp-right').hide();
                $("#departementCoemprunteurStatic").show();
                $("#departementCoemprunteurStaticError").hide();
                return false;
            }
        });
    }


    /**
     * Toutes les étapes
     */
    clickOnRadioInput();
    $('.gsp_button_rappel').on('click', function () {
        let href = $(".gsp_button_rappel").attr("href");
        window.location = href;
    });

    function declencherCalculMontantRestant() {
        $('#pretMontant1, #pretMontant2, #pretMontant3').on('change', function () {
            calculMontantRestantDevisGsp();
        });
        $('#pretMontant1, #pretMontant2, #pretMontant3').on('blur', function () {
            calculMontantRestantDevisGsp();
        });
        $('#totalMontant').keyup(function () {
            if (this.value.length > 3 && parseInt(this.value) > 0 && $("#pret_financement_financementSeul").is(":checked")) {
                declencherCalculMontantRestant();
                calculMontantRestantDevisGsp();
            }
        });
        $('#pret_financement_FinancementSeul, #pret_financement_FinancementPlusieurs, #pretMontant1, #pretMontant2, #pretMontant3, #pret_cbPret_2, #pret_cbPret_3, #pret_cbPret_4').keypress(function (e) {
            let key = e.which;
            if (key == 13) {
                calculMontantRestantDevisGsp();
            }
        });

        $('#pret_financement_FinancementSeul, #pret_financement_FinancementPlusieurs, #pretMontant1, #pretMontant2, #pretMontant3, #pret_cbPret_2, #pret_cbPret_3, #pret_cbPret_4').on('keyDown', function () {
            calculMontantRestantDevisGsp();
        });
    }

    function calculMontantRestantDevisGsp() {
        if ($("#pret_financement_FinancementPlusieurs").is(":checked")) {
            if ($('#pret_cbPret_2').is(':checked')) {
                checkSaisieMontantPret(2);
            }
            if ($('#pret_cbPret_3').is(':checked')) {
                checkSaisieMontantPret(3);
            }
            if ($('#pret_cbPret_4').is(':checked')) {
                checkSaisieMontantPret(4);
            }
        }
        if ($("#pret_financement_financementSeul").is(":checked")) {
            $("#ElodieDepasseTotalMontantPret1").hide();
            $("#ElodieDepasseTotalMontantPret2").hide();
            $("#ElodieDepasseTotalMontantPret3").hide();
            checkSaisieMontantPret(1);
        }
    }

    function afficherBloc(nameBloc) {
        switch (nameBloc) {
            case 'garanties[iptiQuestionEmprunteur]':
                $("input[name='" + nameBloc + "']").each(function () {
                    if ($(this).prop("checked") === true) {
                        if ($(this).attr('id') === "garanties_iptiQuestionEmprunteur_OUI") {
                            $(".IPTEmprunteur").removeClass("collapse").addClass("collapsed");
                        } else {
                            $(".IPTEmprunteur").removeClass("collapsed").addClass("collapse");
                        }
                    }
                });
                break;
            case 'garanties[iptiQuestionCoemprunteur]':
                $("input[name='" + nameBloc + "']").each(function () {
                    if ($(this).prop("checked") === true) {
                        if ($(this).attr('id') === "garanties_iptiQuestionCoemprunteur_OUI") {
                            $(".IPTCoemprunteur").removeClass("collapse").addClass("collapsed");
                        } else {
                            $(".IPTCoemprunteur").removeClass("collapsed").addClass("collapse");
                        }
                    }
                });
                break;
            case 'projet[assuranceConcerne]':
                $("input[name='" + nameBloc + "']").each(function () {
                    if ($(this).prop("checked") === true) {
                        if ($(this).attr('id') === "projet_assuranceConcerne_others") {
                            $("#elodieConseillerAssuranceConcerne").show();
                        } else {
                            $("#elodieConseillerAssuranceConcerne").hide();
                        }
                    } else {
                        $("#elodieConseillerAssuranceConcerne").hide();
                    }
                });
                break;
            case 'projet[projetConcerne]':
                $("input[name='" + nameBloc + "']").each(function () {
                    if ($(this).prop("checked") === true) {
                        if ($(this).attr('id') === "projet_projetConcerne_ASSURE_HORS_AGPM") {
                            $("input[name='projet[assuranceConcerne]']").each(function () {
                                if ($(this).prop("checked") === true) {
                                    if ($(this).attr('id') === "projet_assuranceConcerne_AUT" || $(this).attr('id') === "projet_assuranceConcerne_T") {
                                        $("#elodieLemoine").hide();
                                    } else {
                                        $("#elodieLemoine").show();
                                    }
                                }
                            });
                            $("#elodiebonjour").hide();
                        } else if ($(this).attr('id') === "projet_projetConcerne_NOUVEAU_PRET") {
                            $("#elodieLemoine").hide();
                        }
                    }
                });
                break;
            case 'projet[nbPersonnes]':
                $("input[name='" + nameBloc + "']").each(function () {
                    if ($(this).prop("checked") === true) {
                        if ($(this).attr('id') === "projet_nbPersonnes_1") {
                            $("#elodiedeux").hide();
                        } else if ($(this).attr('id') === "projet_nbPersonnes_2") {
                            $("#elodiebonjour").hide();
                            $("#elodiedeux").show();
                        }
                        $('.questionNbPretLabel').show();
                    } else if ($(this).prop("checked") === false) {
                        $('.questionNbPretLabel').hide();
                        $('.montantDePret').hide();
                    }
                });
                break;
            case 'pret[financement]':
                $("input[name='" + nameBloc + "']").each(function () {
                    if ($(this).prop('id') === "pret_financement_FinancementPlusieurs") {
                        if ($(this).prop("checked") === true) {
                            $('.montantDePret').show();
                            afficherBloc("pret[cbPret]");
                        }
                    } else if ($(this).prop('id') === "pret_financement_financementSeul") {
                        if ($(this).prop("checked") === true) {
                            checkSaisieMontantPret(1);
                        }
                    }
                });
                break;
            case 'pret[cbPret]':
                $("input[name='" + nameBloc + "']").each(function () {
                    if ($(this).prop("checked") === true) {
                        $('.questionNbPretLabel').show();
                        if ($(this).attr('id') === "pret_cbPret_2") {
                            $("#elodieConseiller").hide();
                            $(".montantDePret_1").show();
                            $(".montantDePret_2").show();
                            $('#pretMontant3').attr('disabled', 'disabled');
                            $('#pretMontant3').removeAttr('required');
                            $(".montantDePret_3").hide();
                        } else if ($(this).attr('id') === "pret_cbPret_3") {
                            $("#elodieConseiller").hide();
                            $(".montantDePret_1").show();
                            $(".montantDePret_2").show();
                            $(".montantDePret_3").show();
                            $('#pretMontant1').attr('required', 'required');
                            $('#pretMontant1').removeAttr('disabled');
                            $('#pretMontant2').attr('required', 'required');
                            $('#pretMontant2').removeAttr('disabled');
                            $('#pretMontant3').attr('required', 'required');
                            $('#pretMontant3').removeAttr('disabled');
                        }
                    } else {
                        $("#pret_cbPret_3").prop("checked");
                        $("#elodieConseiller").hide();
                        $(".montantDePret").show();
                        $('#pretMontant1').attr('required', 'required');
                        $('#pretMontant2').attr('required', 'required');
                        $('#pretMontant3').attr('required', 'required');
                    }
                });
                break;
            case 'pret2[pretDiffere1]':
            case 'pret2[pretDiffere2]':
            case 'pret2[pretDiffere3]':
                let numPretDiffere = nameBloc.substr(17, 1);
                $("input[name='pret2[pretDiffere" + numPretDiffere + "]']").each(function () {
                    if ($(this).prop("checked") === true) {
                        if ($(this).attr('id') === "pret2_pretDiffere" + numPretDiffere + "_OUI") {
                            $(".conteneurPretDiffere" + numPretDiffere).removeAttr('style');
                            $('input[name="pret2[natureDiffereAmortissement' + numPretDiffere + ']"]').attr('required', 'required');
                            $('input[name="pret2[dureeDiffereAmortissement' + numPretDiffere + ']"]').attr('required', 'required');
                            $('input[name="pret2[dureeDiffereAmortissementMA' + numPretDiffere + ']"]').attr('required', 'required');
                        }
                    }
                });
                break;
            case 'infosPerso[contratPrevoyanceEmprunteur]':
                $("input[name='" + nameBloc + "']").each(function () {
                    if ($(this).prop("checked") === true) {
                        if ($(this).attr('id') === "infosPerso_contratPrevoyanceEmprunteur_OUI") {
                            $(".contratPrevoyanceCoemprunteurDiv ").removeClass("collapse").addClass("collapsed");
                            $("#elodieContratPrevoyanceEmprunteur").show()
                        } else $("#elodieContratPrevoyanceEmprunteur").hide();
                    }
                });
                break;
            case "infosPerso[contratPrevoyanceCoemprunteur]":
                $("input[name='infosPerso[contratPrevoyanceCoemprunteur]']").each(function () {
                    if ($(this).prop("checked") === true) {
                        if ($(this).attr('id') === "infosPerso_contratPrevoyanceCoemprunteur_NON") {
                            $("#elodieContratPrevoyanceCoemprunteur").hide();
                        } else $("#elodieContratPrevoyanceCoemprunteur").show();
                    }
                });
                break;
        }
    }

    // Permet de desactiver et activer le formulaire
    function desactiveFormSiMultipleRejet(action, idCheck) {

        let needBlock = false, needBlock1 = false, needBlock2 = false, needBlock3 = false, id = "";
        if (idCheck !== undefined) {
            $.each(idCheck, function (index, value) {
                needBlock = true;
                if (value === "pret2[pretType1]") {
                    if ($('#pret2_pretType1_A').is(':checked') || $('#pret2_pretType1_PRET_RELAIS').is(':checked')) {
                        $("#elodieConseillerPretType1").show();
                        $('#pret2_natureDiffereAmortissement1_TOTAL').prop('checked', false);
                        $('#pret2_natureDiffereAmortissement1_PARTIEL').removeAttr('disabled');
                        needBlock1 = true;
                    } else {
                        if ($('#pret2_pretType1_PTZ').is(':checked')) {
                            $('#pret1Taux').prop('value', 0);
                            $('#pret1Taux').prop('min', 0);
                            $('#pret1Taux').prop('readonly', 'readonly');
                            $('#pret2_natureDiffereAmortissement1_TOTAL').prop('checked', 'checked');
                            $('#pret2_natureDiffereAmortissement1_PARTIEL').prop('disabled', 'disabled');
                        }
                        $("#elodieConseillerPretType1").hide();
                    }
                }
                if (value === "pret2[pretType2]") {
                    if ($('#pret2_pretType2_A').is(':checked') || $('#pret2_pretType2_PRET_RELAIS').is(':checked')) {
                        $("#elodieConseillerPretType2").show();
                        $('#pret2_natureDiffereAmortissement2_TOTAL').prop('checked', false);
                        $('#pret2_natureDiffereAmortissement2_PARTIEL').removeAttr('disabled');
                        needBlock2 = true;
                    } else {
                        if ($('#pret2_pretType2_PTZ').is(':checked')) {
                            $('#pret2Taux').prop('value', 0);
                            $('#pret2Taux').prop('min', 0);
                            $('#pret2Taux').prop('readonly', 'readonly');
                            $('#pret2_natureDiffereAmortissement2_TOTAL').prop('checked', 'checked');
                            $('#pret2_natureDiffereAmortissement2_PARTIEL').prop('disabled', 'disabled');
                        }
                        $("#elodieConseillerPretType2").hide();
                    }
                }
                if (value === "pret2[pretType3]") {
                    if ($('#pret2_pretType3_A').is(':checked') || $('#pret2_pretType3_PRET_RELAIS').is(':checked')) {
                        $("#elodieConseillerPretType3").show();
                        $('#pret2_natureDiffereAmortissement3_TOTAL').prop('checked', false);
                        $('#pret2_natureDiffereAmortissement3_PARTIEL').removeAttr('disabled');
                        needBlock3 = true;
                    } else {
                        if ($('#pret2_pretType3_PTZ').is(':checked')) {
                            $('#pret3Taux').prop('value', 0);
                            $('#pret3Taux').prop('min', 0);
                            $('#pret3Taux').prop('readonly', 'readonly');
                            $('#pret2_natureDiffereAmortissement3_TOTAL').prop('checked', 'checked');
                            $('#pret2_natureDiffereAmortissement3_PARTIEL').prop('disabled', 'disabled');
                        }
                        $("#elodieConseillerPretType3").hide();
                    }
                }
            });
            if ((needBlock1 || needBlock2 || needBlock3)) {
                action = true;
                needBlock = true;
            } else {
                action = false;
                needBlock = false;
            }
        }
        if (action === true && needBlock === true) {
            block = true;
            $('form.submit-disabled-if-reject').find(':submit').attr('disabled', 'disabled');
            $('form.submit-disabled-if-reject').find(':submit').addClass('collapse');
        } else if (action === true && needBlock === false) {
            block = true;
            $('form.submit-disabled-if-reject').find(':submit').attr('disabled', 'disabled');
            $('form.submit-disabled-if-reject').find(':submit').addClass('collapse');
        } else {
            block = false;
            $('form.submit-disabled-if-reject').find(':submit').removeAttr('disabled');
            $('form.submit-disabled-if-reject').find(':submit').removeClass('collapse');
        }
    }

    // Permet de saisir les min/max des montants des prets, et calcul du restant à répartir
    // Si tout est OK, on permet d'activer le formulaire
    // Permet de lier les champs à la saisie. Si tu augmentes 1, l'autre descend...
    function checkSaisieMontantPret(nombrePrets, show = true) {
        let blockForm = true;
        let pretMontant1 = parseInt($('#pretMontant1').val());
        let pretMontant2 = parseInt($('#pretMontant2').val());
        let totalMontant = parseInt($('#totalMontant').val());
        let aRepartir = totalMontant;
        $('#pretMontant1').prop('max', totalMontant);

        if (totalMontant < 0) {
            $('#totalMontant').val(0);
            totalMontant = 0;
        }

        if (totalMontant < 1000) {
            $("#ElodieMinTotalMontant").removeClass("collapse").addClass("collapsed");
            $("#ElodieMaxTotalMontant").removeClass("collapsed").addClass("collapse");
            desactiveFormSiMultipleRejet(true);
            $(".financementTitle, .questionNbPretLabel").removeClass("collapsed").addClass("collapse");
        } else if (totalMontant > 999999) {
            $("#ElodieMaxTotalMontant").removeClass("collapse").addClass("collapsed");
            $("#ElodieMinTotalMontant").removeClass("collapsed").addClass("collapse");
            desactiveFormSiMultipleRejet(true);
            $(".financementTitle, .questionNbPretLabel").removeClass("collapsed").addClass("collapse");
        } else if (totalMontant) {
            blockForm = false;
            $("#ElodieMinTotalMontant").removeClass("collapsed").addClass("collapse");
            $(".financementTitle, .questionNbPretLabel").removeClass("collapse").addClass("collapsed");
            $("#ElodieMaxTotalMontant").removeClass("collapsed").addClass("collapse");
        }

        if (nombrePrets === 1) {
            $("#ElodieDepasseTotalMontantPret1").hide();
            $("#ElodieDepasseTotalMontantPret2").hide();
            $("#ElodieDepasseTotalMontantPret3").hide();
            $("#elodieConseiller").hide();
            $(".montantDePret").hide();
            $(".questionNbPretLabel").hide();
            $("#pret_cbPret_0").hide();
            $("#pret_cbPret_2").hide();
            $("#pret_cbPret_3").hide();
            $('#pretMontant1').attr('disabled', 'disabled');
            $('#pretMontant1').removeAttr('required');
            $('#pretMontant2').attr('disabled', 'disabled');
            $('#pretMontant2').removeAttr('required');
            $('#pretMontant3').attr('disabled', 'disabled');
            $('#pretMontant3').removeAttr('required');
            $('.montantDePret_1').hide();
            $('.montantDePret_2').hide();
            $('.montantDePret_3').hide();
            $('#ElodieMinPret1').hide();
            $('#ElodieMaxPret1').hide();
            $('#ElodieMinPret2').hide();
            $('#ElodieMaxPret2').hide();
            $('#ElodieMinPret3').hide();
            $('#ElodieMaxPret3').hide();
            aRepartir = totalMontant;
            blockForm = false;
        }
        if (nombrePrets === 2) {
            $("#elodieConseiller").hide();
            if (show === true) {
                $(".montantDePret_1").show();
                $(".montantDePret_2").show();
                $('#pretMontant1').attr('required', 'required');
                $('#pretMontant1').removeAttr('disabled');
                $('#pretMontant2').attr('required', 'required');
                $('#pretMontant2').removeAttr('disabled');
            }
            $(".montantDePret_3").hide();
            $('#pretMontant3').attr('disabled', 'disabled');
            $('#pretMontant3').removeAttr('required');
            if ((pretMontant1 != "") && (pretMontant1 > 0) && (pretMontant1 <= totalMontant)) {
                // Si on a saisi un premier montant, on relimite le max pour montant2
                pretMontant2 = totalMontant - pretMontant1;
                $('#pretMontant2').prop('max', pretMontant2);
                $('#pretMontant2').val(pretMontant2);
                aRepartir = totalMontant - pretMontant1 - pretMontant2;
                blockForm = false;
            }
        }
        if (nombrePrets === 3) {
            $("#elodieConseiller").hide();
            $(".montantDePret").show();
            $(".montantDePret_3").show();
            $('#pretMontant1').attr('required', 'required');
            $('#pretMontant2').attr('required', 'required');
            $('#pretMontant3').attr('required', 'required');
            $('#pretMontant1').removeAttr('disabled');
            $('#pretMontant2').removeAttr('disabled');
            $('#pretMontant3').removeAttr('disabled');
            if ((pretMontant1 != "") && (pretMontant1 > 0) && (pretMontant1 <= totalMontant) && isNaN(pretMontant2)) {
                aRepartir = totalMontant - pretMontant1;
                $('#pretMontant2').attr('max', aRepartir);
                $('#calculMontantRestantDevisGsp').html("<span class='text-success'>" + euro.format(aRepartir) + "</span>");
                $('#pretMontant3').prop('max', 0);
            }
            if ((pretMontant2 != "") && (pretMontant2 >= 0) && (parseInt(aRepartir) <= totalMontant)) {
                aRepartir = totalMontant - (pretMontant1 + pretMontant2);
                $('#pretMontant3').prop('max', aRepartir);
                $('#pretMontant3').prop('min', 1000);
                if (aRepartir >= 0 && aRepartir <= totalMontant) {
                    $('#calculMontantRestantDevisGsp').html("<span class='text-success'>" + euro.format(aRepartir) + "</span>");
                }
            }
            let pretMontant3 = parseInt($('#pretMontant3').val());
            if ((pretMontant3 != "") && (pretMontant3 >= 0) && (parseInt(aRepartir) <= totalMontant)) {
                aRepartir = totalMontant - (pretMontant1 + pretMontant2 + pretMontant3);
                if (aRepartir >= 0 && aRepartir <= totalMontant) {
                    $('#calculMontantRestantDevisGsp').html("<span class='text-success'>" + euro.format(aRepartir) + "</span>");
                }
                blockForm = false;
                if (pretMontant3 < 1000) {
                    blockForm = true;
                    $("#ElodieMinPret3").show();
                } else $("#ElodieMinPret3").hide();
                if (pretMontant3 > totalMontant) {
                    blockForm = true;
                    $("#ElodieDepasseTotalMontantPret3").show();
                } else $("#ElodieDepasseTotalMontantPret3").hide();

            }
            if (((pretMontant1 + pretMontant2) >= totalMontant)) {
                blockForm = true;
                $('#calculMontantRestantDevisGsp').html("<span class='text-danger'>" + euro.format(aRepartir) + "</span>");
            }
        }
        if (pretMontant1 < 1000) {
            blockForm = true;
            $("#ElodieMinPret1").show();
        } else $("#ElodieMinPret1").hide();

        if (pretMontant1 > totalMontant) {
            blockForm = true;
            $("#ElodieDepasseTotalMontantPret1").show();
        } else $("#ElodieDepasseTotalMontantPret1").hide();

        if (pretMontant2 < 1000) {
            blockForm = true;
            $("#ElodieMinPret2").show();
        } else $("#ElodieMinPret2").hide();

        if (pretMontant2 > totalMontant) {
            blockForm = true;
            $("#ElodieDepasseTotalMontantPret2").show();
        } else $("#ElodieDepasseTotalMontantPret2").hide();

        if (aRepartir === totalMontant && !blockForm && $("#pret_financement_financementSeul").is(":checked")) {
            $('#calculMontantRestantDevisGsp').html("<span class='text-success'>" + euro.format(aRepartir) + "</span>");
            desactiveFormSiMultipleRejet(false);
        } else if (aRepartir === 0 && !blockForm && $("#pret_financement_FinancementPlusieurs").is(":checked")) {
            $('#calculMontantRestantDevisGsp').html("<span class='text-success'>" + euro.format(aRepartir) + "</span>");
            desactiveFormSiMultipleRejet(false);
        } else desactiveFormSiMultipleRejet(true);

    }

    function setNouvellesValInputRange(object, val, valMinApi, input) {
        if (val < valMinApi) {
            object.val(valMinApi);
            object.next().html(valMinApi + "%");
        }
        let valEmprunteur = val;
        if (valEmprunteur < 10) valEmprunteur = 10;
        if ($("#ipti" + input).length > 0) {
            let valCoemprunteur = $("#ipti" + input).val();
            if (100 - valEmprunteur >= 10 && valCoemprunteur < (100 - valEmprunteur)) {
                $("#ipti" + input).val(100 - valEmprunteur);
                $("#ipti" + input).next().html((100 - valEmprunteur) + "%");
                $("#ipt" + input).val(100 - valEmprunteur);
                $("#ipt" + input).next().html((100 - valEmprunteur) + "%");
                $("#ipp" + input).val(100 - valEmprunteur);
                $("#ipp" + input).next().html((100 - valEmprunteur) + "%");
            }
        }
    }

    function setNouvellesValInputRangeCoemprunteur(object, val, valMinApi, input) {
        if (val < valMinApi) {
            object.val(valMinApi);
            object.next().html(valMinApi + "%");
        }
        let valCoemprunteur = val;
        if (valCoemprunteur < 10) valCoemprunteur = 10;
        if ($("#ipti" + input).length > 0) {
            let valEmprunteur = $("#ipti" + input).val();
            if (100 - valCoemprunteur >= 10 && valEmprunteur < (100 - valCoemprunteur)) {
                $("#ipti" + input).val(100 - valCoemprunteur);
                $("#ipti" + input).next().html((100 - valCoemprunteur) + "%");
                $("#ipt" + input).val(100 - valCoemprunteur);
                $("#ipt" + input).next().html((100 - valCoemprunteur) + "%");
                $("#ipp" + input).val(100 - valCoemprunteur);
                $("#ipp" + input).next().html((100 - valCoemprunteur) + "%");
            }
        }
    }

    function clickOnRadioInput() {
        $('.clickOn').on('click', function () {
            switch ($(this).data('id')) {
                case "0":
                    $(".montantDePret").hide();
                    $("#elodieConseiller").show();
                    desactiveFormSiMultipleRejet(true);
                    $('#ElodieMinPret1').hide();
                    $('#ElodieMaxPret1').hide();
                    $('#ElodieMinPret2').hide();
                    $('#ElodieMaxPret2').hide();
                    $('#ElodieMinPret3').hide();
                    $('#ElodieMaxPret3').hide();
                    break;
                case "2":
                    checkSaisieMontantPret(2);
                    $("#elodieConseiller").hide();
                    $(".montantDePret").show();
                    $('#pretMontant3').attr('disabled', 'disabled');
                    $('#pretMontant3').removeAttr('required');
                    $(".montantDePret_3").hide();
                    $('#ElodieMinPret3').hide();
                    $('#ElodieMaxPret3').hide();
                    break;
                case "3":
                    checkSaisieMontantPret(3);
                    $("#elodieConseiller").hide();
                    $(".montantDePret").show();
                    $(".montantDePret_3").show();
                    $('#pretMontant3').attr('required', 'required');
                    $('#pretMontant3').removeAttr('disabled');
                    break;
            }
        });

        $('input[type="radio"]').on('click', function () {
            if (block && (nameOfRejects.includes(this.name))) desactiveFormSiMultipleRejet(false);
            if (this.name === "projet[assuranceConcerne]") $("#elodieConseillerAssuranceConcerne").hide();
            if (nameOfRejectsPretType.includes(this.name)) desactiveFormSiMultipleRejet(true, nameOfRejectsPretType);
            switch (this.id) {
                case "garanties_iptiQuestionEmprunteur_OUI":
                    $(".IPTEmprunteur").removeClass("collapse").addClass("collapsed");
                    break;
                case "garanties_iptiQuestionEmprunteur_NON":
                    $(".IPTEmprunteur").removeClass("collapsed").addClass("collapse");
                    break;
                case "garanties_iptiQuestionCoemprunteur_OUI":
                    $(".IPTCoemprunteur").removeClass("collapse").addClass("collapsed");
                    break;
                case "garanties_iptiQuestionCoemprunteur_NON":
                    $(".IPTCoemprunteur").removeClass("collapsed").addClass("collapse");
                    break;
                case "pret2_pretDiffere1_OUI":
                case "pret2_pretDiffere1_NON":
                case "pret2_pretDiffere2_OUI":
                case "pret2_pretDiffere2_NON":
                case "pret2_pretDiffere3_OUI":
                case "pret2_pretDiffere3_NON":
                    let subId = this.id.substr(17, 5);
                    let numId = subId.substr(0, 1);
                    let valId = subId.substr(2, 3);
                    if (valId === "OUI") {
                        $(".conteneurPretDiffere" + numId).show();
                        $('input[name="pret2[natureDiffereAmortissement' + numId + ']"]').prop('required', 'required');
                        $('input[name="pret2[dureeDiffereAmortissement' + numId + ']"]').prop('required', 'required');
                        $('input[name="pret2[dureeDiffereAmortissementMA' + numId + ']"]').prop('required', 'required');
                        if ($("#pret2_pretType" + numId + "_PTZ").prop("checked") === true) {
                            $('#pret2_natureDiffereAmortissement' + numId + '_TOTAL').prop('checked', 'checked');
                            $('#pret2_natureDiffereAmortissement' + numId + '_PARTIEL').prop('disabled', 'disabled');
                        } else {
                            $('#pret2_natureDiffereAmortissement' + numId + '_TOTAL').prop('checked', false);
                            $('#pret2_natureDiffereAmortissement' + numId + '_PARTIEL').removeAttr('disabled');
                        }
                    } else {
                        $('input[name="pret2[natureDiffereAmortissement' + numId + ']"]').removeAttr('required');
                        $('input[name="pret2[dureeDiffereAmortissement' + numId + ']"]').removeAttr('required');
                        $('input[name="pret2[dureeDiffereAmortissementMA' + numId + ']"]').removeAttr('required');
                        $(".conteneurPretDiffere" + numId).hide();
                        $('#pret2_natureDiffereAmortissement' + numId + '_TOTAL').prop('checked', false);
                        $('#pret2_natureDiffereAmortissement' + numId + '_PARTIEL').removeAttr('disabled');
                    }
                    break;
                case "pret2_pretType1_AMORTISSABLE":
                case "pret2_pretType2_AMORTISSABLE":
                case "pret2_pretType3_AMORTISSABLE":
                case "pret2_pretType1_PTZ":
                case "pret2_pretType2_PTZ":
                case "pret2_pretType3_PTZ":
                    let subTypeId = this.id.substr(14, 14);
                    let numTypeId = subTypeId.substr(0, 1);
                    let valTypeId = subTypeId.substr(2, 13);
                    if (valTypeId === "AMORTISSABLE") {
                        $('#pret' + numTypeId + 'Taux').prop('min', 0.01);
                        $('#pret' + numTypeId + 'Taux').removeAttr('readonly');
                        $('#pret2_natureDiffereAmortissement' + numTypeId + '_TOTAL').prop('checked', false);
                        $('#pret2_natureDiffereAmortissement' + numTypeId + '_PARTIEL').removeAttr('disabled');
                    } else if (valTypeId === "PTZ") {
                        $('#pret' + numTypeId + 'Taux').prop('value', 0);
                        $('#pret' + numTypeId + 'Taux').prop('min', 0);
                        $('#pret' + numTypeId + 'Taux').prop('readonly', 'readonly');
                        $('#pret2_natureDiffereAmortissement' + numTypeId + '_TOTAL').prop('checked', 'checked');
                        $('#pret2_natureDiffereAmortissement' + numTypeId + '_PARTIEL').prop('disabled', 'disabled');
                    }
                    break
                case "projet_assuranceConcerne_RP":
                case "projet_assuranceConcerne_RS":
                case "projet_assuranceConcerne_IL":
                case "projet_assuranceConcerne_others":
                    if (this.id === "projet_assuranceConcerne_others") {
                        desactiveFormSiMultipleRejet(true);
                        $("#elodieConseillerAssuranceConcerne").show();
                    }
                    $("input[name='projet[projetConcerne]']").each(function () {
                        if ($(this).prop("checked") === true) {
                            if ($(this).attr('id') === "projet_projetConcerne_ASSURE_HORS_AGPM") {
                                $("#elodieLemoine").show();
                            } else {
                                $("#elodieLemoine").hide();
                            }
                        }
                    });
                    break;
                case "projet_assuranceConcerne_AUT":
                case "projet_assuranceConcerne_T":
                case "projet_projetConcerne_NOUVEAU_PRET":
                    $("#elodieLemoine").hide();
                    break;
                case "projet_projetConcerne_ASSURE_HORS_AGPM":
                    $("input[name='projet[assuranceConcerne]']").each(function () {
                        if ($(this).prop("checked") === true) {
                            if ($(this).attr('id') === "projet_assuranceConcerne_AUT" || $(this).attr('id') === "projet_assuranceConcerne_T") {
                                $("#elodieLemoine").hide();
                            } else {
                                $("#elodieLemoine").show();
                            }
                        }
                    });
                    break;
                case "projet_nbPersonnes_1":
                    $("#elodiedeux").hide();
                    break;
                case "projet_nbPersonnes_2":
                    $("#elodiebonjour").hide();
                    $("#elodiedeux").show();
                    break;
                case "pret_financement_FinancementPlusieurs":
                    if ($("#pret_cbPret_3").is(":checked")) {
                        checkSaisieMontantPret(3, false);
                        $("#elodieConseiller").hide();
                        $(".montantDePret").show();
                        $(".montantDePret_3").show();
                        $('#pretMontant3').attr('required', 'required');
                        $('#pretMontant3').removeAttr('disabled');
                    } else {
                        $("#pret_cbPret_2").prop("checked", "checked");
                        checkSaisieMontantPret(2, false);
                        $("#elodieConseiller").hide();
                        $(".montantDePret").show();
                        $('#pretMontant3').attr('disabled', 'disabled');
                        $('#pretMontant3').removeAttr('required');
                        $(".montantDePret_3").hide();
                        $('#ElodieMinPret3').hide();
                        $('#ElodieMaxPret3').hide();
                        $('#pretMontant2').attr('required', 'required');
                        $('#pretMontant2').removeAttr('disabled');
                        $('#pretMontant1').attr('required', 'required');
                        $('#pretMontant1').removeAttr('disabled');
                    }
                    $("#elodieConseiller").hide();
                    $(".questionNbPretLabel").show();
                    break;
                case "pret_financement_financementSeul":
                    $('#pretMontant1').val("");
                    $('#pretMontant2').val("");
                    $('#pretMontant3').val("");
                    checkSaisieMontantPret(1);
                    $('#ElodieMinPret1').hide();
                    $('#ElodieMaxPret1').hide();
                    $('#ElodieMinPret2').hide();
                    $('#ElodieMaxPret2').hide();
                    $('#ElodieMinPret3').hide();
                    $('#ElodieMaxPret3').hide();
                    break;
                case "pret_cbPret_0":
                case "pret_cbPret_2":
                case "pret_cbPret_3":
                    let numCbPretId = this.id.substr(12, 1);
                    if (numCbPretId === "0") {
                        $(".montantDePret").hide();
                        $("#elodieConseiller").show();
                        desactiveFormSiMultipleRejet(true);
                        $('#ElodieMinPret1').hide();
                        $('#ElodieMaxPret1').hide();
                        $('#ElodieMinPret2').hide();
                        $('#ElodieMaxPret2').hide();
                        $('#ElodieMinPret3').hide();
                        $('#ElodieMaxPret3').hide();
                    } else if (numCbPretId === "2") {
                        checkSaisieMontantPret(2);
                        $("#elodieConseiller").hide();
                        $(".montantDePret").show();
                        $('#pretMontant3').attr('disabled', 'disabled');
                        $('#pretMontant3').removeAttr('required');
                        $(".montantDePret_3").hide();
                        $('#ElodieMinPret3').hide();
                        $('#ElodieMaxPret3').hide();
                        $('#pretMontant1').attr('required', 'required');
                        $('#pretMontant1').removeAttr('disabled');
                        $('#pretMontant2').attr('required', 'required');
                        $('#pretMontant2').removeAttr('disabled');
                    } else if (numCbPretId === "3") {
                        checkSaisieMontantPret(3);
                        $("#elodieConseiller").hide();
                        $(".montantDePret").show();
                        $(".montantDePret_3").show();
                        $('#pretMontant3').attr('required', 'required');
                        $('#pretMontant3').removeAttr('disabled');
                    }
                    break;
                case "infosPerso_contratPrevoyanceEmprunteur_NON":
                    $("#elodieContratPrevoyanceEmprunteur").hide();
                    $("input[name='infosPerso[contratPrevoyanceCoemprunteur]']").attr('disabled', 'disabled');
                    $("input[name='infosPerso[contratPrevoyanceCoemprunteur]']").removeAttr('required');
                    $('.contratPrevoyanceCoemprunteurDiv').removeClass("collapsed").addClass("collapse");
                    break;
                case "infosPerso_contratPrevoyanceEmprunteur_OUI":
                    $("#elodieContratPrevoyanceEmprunteur").show();
                    $("input[name='infosPerso[contratPrevoyanceCoemprunteur]']").attr('required', 'required');
                    $("input[name='infosPerso[contratPrevoyanceCoemprunteur]']").removeAttr('disabled');
                    $('.contratPrevoyanceCoemprunteurDiv').removeClass("collapse").addClass("collapsed");
                    break;
                case "infosPerso_contratPrevoyanceCoemprunteur_NON":
                    $("#elodieContratPrevoyanceCoemprunteur").hide();
                    break;
                case "infosPerso_contratPrevoyanceCoemprunteur_OUI":
                    $("#elodieContratPrevoyanceCoemprunteur").show();
                    break;
                case "pret2_dureeDiffereAmortissementMA1_mois":
                case "pret2_dureeDiffereAmortissementMA1_annees":
                case "pret2_dureeDiffereAmortissementMA2_mois":
                case "pret2_dureeDiffereAmortissementMA2_annees":
                case "pret2_dureeDiffereAmortissementMA3_mois":
                case "pret2_dureeDiffereAmortissementMA3_annees":
                    let subDureeDiffereAmortissementId = this.id.substr(33, 8);
                    let numDureeDiffereAmortissementId = subDureeDiffereAmortissementId.substr(0, 1);
                    let valDureeDiffereAmortissementId = subDureeDiffereAmortissementId.substr(2, 6);
                    if (valDureeDiffereAmortissementId === "mois") {
                        checkDureePret("pret2[dureeDiffereAmortissement" + numDureeDiffereAmortissementId + "]", "month");
                    } else if (valDureeDiffereAmortissementId === "annees") {
                        checkDureePret("pret2[dureeDiffereAmortissement" + numDureeDiffereAmortissementId + "]", "year");
                    }
                    break;
                case "pret2_pretDureeMA1_mois":
                case "pret2_pretDureeMA1_annees":
                case "pret2_pretDureeMA2_mois":
                case "pret2_pretDureeMA2_annees":
                case "pret2_pretDureeMA3_mois":
                case "pret2_pretDureeMA3_annees":
                    let subPretDureeId = this.id.substr(17, 8);
                    let numPretDureeId = subPretDureeId.substr(0, 1);
                    let valPretDureeId = subPretDureeId.substr(2, 6);
                    if (valPretDureeId === "mois") {
                        checkDureePret("pret2[pretDuree" + numPretDureeId + "]", "month");
                    } else if (valPretDureeId === "annees") {
                        checkDureePret("pret2[pretDuree" + numPretDureeId + "]", "year");
                    }
                    break;
            }
        });
    }

    function checkDureePret(nameInput, duree) {
        if (nameInput === "pret2[pretDuree1]" || nameInput === "pret2[pretDuree2]" || nameInput === "pret2[pretDuree3]") {
            let max = parseInt($("input[name='" + nameInput + "']").attr('max'));
            if (duree === "year") max = parseInt(max / 12);
            let min = 6;
            if (duree === "year") min = min / 12;
            let val = parseInt($("input[name='" + nameInput + "']").val());
            let step = $("input[name='" + nameInput + "']").data("step");
            if (val > max) {
                $('#ElodieMaxDuree' + step).show();
                $('#ElodieMinDuree' + step).hide();
                desactiveFormSiMultipleRejet(true);
            }
            if (val <= min) {
                $('#ElodieMaxDuree' + step).hide();
                $('#ElodieMinDuree' + step).show();
                desactiveFormSiMultipleRejet(true);
            }
            if (val > min && val <= max) {
                $('#ElodieMaxDuree' + step).hide();
                $('#ElodieMinDuree' + step).hide();
                desactiveFormSiMultipleRejet(false);
            }
        }
        if (nameInput === "pret2[dureeDiffereAmortissement1]" || nameInput === "pret2[dureeDiffereAmortissement2]" || nameInput === "pret2[dureeDiffereAmortissement3]") {
            let max = parseInt($("input[name='" + nameInput + "']").attr('max'));
            if (duree === "year") max = parseInt(parseInt(max) / 12);
            let min = 0;
            if (duree === "year") min = min / 12;
            let val = parseInt($("input[name='" + nameInput + "']").val());
            let step = $("input[name='" + nameInput + "']").data("step");
            if (val > max) {
                $('#ElodieMaxDureeAmortissement' + step).show();
                $('#ElodieMinDureeAmortissement' + step).hide();
                desactiveFormSiMultipleRejet(true);
            }
            if (val <= min) {
                $('#ElodieMinDureeAmortissement' + step).show();
                $('#ElodieMaxDureeAmortissement' + step).hide();
                desactiveFormSiMultipleRejet(true);
            }
            if (val > min && val <= max) {
                $('#ElodieMaxDureeAmortissement' + step).hide();
                $('#ElodieMinDureeAmortissement' + step).hide();
                desactiveFormSiMultipleRejet(false);
            }
        }
    }

    function afficherValueInputRange() {
        $('input[type="range"]').each(function () {
            $(this).next().html($(this).val() + '%');
        });
    }
});
